<template>
  <div class="home-container">
    <div class="init-chat-bot">
      <div style="width: 90%; margin-bottom: 85px">
        <v-img
          class="position-relative cssa-logo-img"
          :src="require('@/assets/images/logo-cssa.jpg')">
        </v-img>
        <div class="text-gradient text-center">
          CSSA
        </div>
        <div class="text-center" style="width: 100%; bottom: 30px; color: #707070">
          您的智能服务私人助理
        </div>

        <div style="left: 0;">
          <div class="question-list" style="padding: 0 5%">
            <div style="
              font-weight: 400;
              line-height: 70px;
              text-align: left;
              color: #333;"
            >
              您可以试着问问下面相关内容：
            </div>
            <div v-for="(item, index) in commonQuestionList"
                 @click="toChat(item)"
                 class="d-flex align-center justify-space-between mb-2 pl-6 pr-6 question-item"
                 :key="index">
              <div>{{ item }}</div>
              <svg-icon style="width: 20px; height: 20px" icon-class="icon-前往"></svg-icon>
            </div>
          </div>
          <div style="position: absolute; bottom: 0; left: 0; background-color: #ffffff">
            <chatInput
              :inputWidth="windowWidth" @sendMessage='sendMessage'
            ></chatInput>
            <!--        <message-input :inputWidth="windowInnerWidth * 0.8" style="margin-top: 15px"-->
            <!--                       @sendMessage='sendMessage'></message-input>-->
            <div style="font-size: 12px; text-align: center; font-family: Graphik,serif;" class="mt-2">
              Copyright 2001-{{ new Date().getFullYear() }} © Accenture.All rights reserved.Accenture
              Confidential.For
              internal use only.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mdiArrowUpCircle,
  mdiMessageText,
  mdiSend,
  mdiThumbUpOutline,
  mdiArrowUp,
  mdiAttachment,
  mdiFileDocumentOutline,
  mdiCloudUpload,
  mdiWindowClose,
  mdiCogOutline,
} from '@mdi/js'
import chatInput from './chat-input'
import { store } from '@/myops/core'

export default {
  components: {
    chatInput,
  },
  data() {
    return {
      isLandscape: window.innerWidth >= window.innerHeight,
      isIphoneSE: false,
      newMessage: null,
      openDeepSeek: false,
      icons: {
        mdiArrowUpCircle,
        mdiMessageText,
        mdiSend,
        mdiThumbUpOutline,
        mdiArrowUp,
        mdiAttachment,
        mdiFileDocumentOutline,
        mdiCloudUpload,
        mdiWindowClose,
        mdiCogOutline,
      },
      modelName: 'DeepSeek-R1-联网满血版',
      adminCogEnter: false,
      commonQuestionList: [
        '请帮我预订一间会议室',
        '如何连接埃森哲的VPN',
        '为配合MD一起出差能预订公务舱吗？',
      ],
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight - 150 - 46,
    }
  },
  computed: {
    firstName() {
      return store.state.user.user.userExInfo.sapPersonalInfo.firstName || store.state.user.user.eid
    },
    isOpsSuperAdmin() {
      const roleList = store.state.user.user.userExInfo.roleList || []
      return roleList.includes('ops_01')
    },
  },
  mounted() {
    this.checkIphoneSE()
    window.addEventListener('resize', this.checkIphoneSE)
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('resize', this.checkIphoneSE)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
      this.isLandscape = window.innerWidth >= window.innerHeight
    },
    checkIphoneSE() {
      // iPhone SE (1st gen): 320x568
      // iPhone SE (2nd/3rd gen): 375x667
      const width = window.innerWidth
      const height = window.innerHeight
      console.log('width: ', width, 'height: ', height)

      this.isIphoneSE = (width <= 320 && height <= 568) ||
        (width <= 375 && height <= 667) || height <= 720
    },
    setModelType(modelType) {
      store.commit('chat/SET_MODEL_TYPE', modelType)
    },
    sendMessage(message) {
      this.$emit('sendMessage', message)
    },
    toChat(item) {
      this.sendMessage(item)
    },
  },
}
</script>
<style scoped>
.home-container {
  height: 100%;
}

.init-chat-bot {
  margin: 15% auto;
  display: grid;
  place-items: center; /* 同时实现水平和垂直居中 */
  border: none;
}

.text-gradient {
  /* 设置渐变背景 */
  background: linear-gradient(294.63deg, #562cdf 0%, #d69cff 100%);
  /* 将背景裁剪到文字区域 */
  -webkit-background-clip: text;
  background-clip: text;
  /* 文字颜色设为透明（让背景渐变显示出来） */
  color: transparent;
  /* 兼容旧版 WebKit 浏览器（可选） */
  -webkit-text-fill-color: transparent;
  font-size: 2rem;
  font-weight: bold;
}

.cssa-logo-img {
  margin: 0 auto;
  height: 123px;
  width: 123px;
  border-radius: 50%;
}

.question-list {
  margin-top: 2%;
}

.question-item {
  width: 100%;
  height: 2.5rem;
  font-size: 14px;
  border-radius: 28px;
  background: #f8f5fd;
  color: #000;
}

/* 1. 小屏手机（如 iPhone SE，320px ~ 359px） */
@media (min-width: 320px) and (max-width: 376px) {
  .init-chat-bot {
    margin: 25px auto;
    display: grid;
    place-items: center; /* 同时实现水平和垂直居中 */
    border: none;
  }
}

/* 2. 普通手机（主流机型，360px ~ 479px） */
@media (min-width: 377px) and (max-width: 479px) {
  .init-chat-bot {
    margin: 20% auto;
    display: grid;
    place-items: center; /* 同时实现水平和垂直居中 */
    border: none;
  }

  .question-list {
    margin-top: 18%;
  }

  .question-item {
    width: 100%;
    height: 3rem;
    font-size: 14px;
    border-radius: 28px;
    background: #f8f5fd;
    color: #000;
  }
}

/* 3. 大屏手机/折叠屏外屏（480px ~ 767px） */
@media (min-width: 480px) and (max-width: 767px) {
  .init-chat-bot {
    margin: 10% auto;
    display: grid;
    place-items: center; /* 同时实现水平和垂直居中 */
    border: none;
  }

  .question-list {
    margin-top: 10%;
  }

  .cssa-logo-img {
    margin: 0 auto;
    height: 123px;
    width: 123px;
    border-radius: 50%;
  }

  .question-item {
    width: 100%;
    height: 2.5rem;
    font-size: 14px;
    border-radius: 28px;
    background: #f8f5fd;
    color: #000;
  }
}

/* 4. 平板（≥ 768px） */
@media (min-width: 768px) {
  .init-chat-bot {
    margin: 15% auto;
    display: grid;
    place-items: center; /* 同时实现水平和垂直居中 */
    border: none;
  }

  .cssa-logo-img {
    margin: 0 auto;
    height: 123px;
    width: 123px;
    border-radius: 50%;
  }

  .question-list {
    margin-top: 18%;
  }

  .question-item {
    width: 100%;
    height: 3rem;
    font-size: 14px;
    border-radius: 28px;
    background: #f8f5fd;
    color: #000;
  }
}
</style>
